// /auth/redirect
import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import axios from "axios";

export default function MicrosoftRedirect() {
  const { instance } = useMsal();

  useEffect(() => {
    const handleRedirect = async () => {
      const response = await instance.handleRedirectPromise();
      if (response) {
        const idToken = response.idToken;
        const email = response.account.username;

        const res = await axios.post("http://localhost:4000/auth/microsoft", {
          idToken,
          email,
        });

        localStorage.setItem("token", res.data.token);
        window.location.href = "/home"; 

        console.log(idToken);
      }
    };

    handleRedirect();
  }, [instance]);

  return <div>Signing you in...</div>;
}
